import { createRoot } from 'react-dom/client';
import { AppProviders } from './providers';
import { AppRoutes } from './routes';
import './styles/global.css';
import './styles/animations.css';

createRoot(document.getElementById('root')!).render(
  <AppProviders>
    <AppRoutes />
  </AppProviders>
);
